<template>
  <div style="width: 100%; height: 100%">
    <div
      style="
        width: 0.5376vw;
        height: 100%;
        display: flex;
        float: left;
        background: rgba(240, 240, 240, 1);
      "
    ></div>
    <div style="width: 6%; height: 100%; float: left; display: flex"></div>
    <div style="width: 93%; height: 100%; float: left; overflow: auto">
      <div style="width: 100%; height: 4.5%"></div>
      <div
        style="width: 100%; height: 5.5%; align-items: center; display: flex"
      >
        <div
          style="
            width: 20%;
            height: 100%;
            float: left;
            align-items: center;
            display: flex;
          "
          class="v41_161"
        >
          <span v-if="Lflag == true" class="v35_1047" style="width: 15%"
            >设备控制</span
          >
          <span v-if="Lflag == false" class="v35_1047" style="width: 15%"
            >Device control</span
          >
        </div>
        <div
          style="
            width: 75%;
            height: 100%;
            float: left;
            align-items: center;
            display: flex;
            justify-content: right;
          "
          class="v41_161"
        >
          <el-button
            @click="drawer = true"
            type="primary"
            style="margin-left: 16px"
          >
            <span v-if="Lflag"> 厂商界面</span>
            <span v-else>DeBug</span>
          </el-button>

          <el-drawer
            :visible.sync="drawer"
            :with-header="false"
            direction="ltr"
            :modal="false"
          >
            <div style="display: flex; justify-content: flex-end; gap: 1vw">
              <button
                style="
                  background: rgba(25, 44, 250, 1);
                  color: white;
                  border: none;
                  border-radius: 0.3vw;
                  padding: 0.6vw 1.5vw;
                  font-size: 0.8vw;
                  cursor: pointer;
                  transition: background 0.3s;
                "
                @click="reset_flag = true"
              >
                <i class="fa fa-save mr-1"></i>
                <span v-if="Lflag">设备重启</span>
                <span v-else>Restart</span>
              </button>
            </div>
          </el-drawer>
          <el-dialog :visible.sync="reset_flag" width="30%">
            <span>是否确认重启仪器</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="reset_flag = false">取 消</el-button>
              <el-button type="primary" @click="restart()">确 定</el-button>
            </span>
          </el-dialog>
          <div
            style="
              width: 5%;
              height: 100%;
              float: left;
              align-items: center;
              display: flex;
              justify-content: right;
            "
            class="v41_161"
          ></div>
          <button
            @click="refresh"
            style="
              background: #6c757d;
              color: white;
              border: none;
              border-radius: 0.3vw;
              padding: 0.6vw 1vw;
              font-size: 0.8vw;
              cursor: pointer;
              transition: background 0.3s;
              display: inline-flex;
              align-items: center;
              justify-content: center;
            "
            :disabled="isRefreshing"
          >
            <!-- 加载图标：仅在isRefreshing为true时显示 -->
            <i class="fa fa-spinner fa-spin mr-1" v-if="isRefreshing"></i>

            <!-- 刷新图标：仅在非加载状态显示 -->
            <i class="fa fa-refresh mr-1" v-else></i>

            <!-- 按钮文字 -->
            <span v-if="Lflag">
              {{ isRefreshing ? "更新中..." : "参数状态更新" }}
            </span>
            <span v-else>
              {{ isRefreshing ? "Updating..." : "Update Parameter Status" }}
            </span>
          </button>
        </div>
      </div>

      <!-- 截止阀控制区 -->
      <div style="width: 40%; height: 90%; float: left">
        <div
          style="
            width: 100%;
            display: flex;

            align-items: center;
            margin-bottom: 1.5vw;
          "
        >
          <h2
            style="
              width: 70%;
              font-size: 1.2vw;
              font-weight: bold;
              color: #333;
              display: flex;
              align-items: center;
            "
          >
            <i style="color: rgba(25, 44, 250, 1)"></i>
            <span v-if="Lflag">截止阀控制区</span>
            <span v-else>Stop Valve Control Area</span>
          </h2>
          <span
            style="
              background: rgba(25, 44, 250, 0.1);
              color: rgba(25, 44, 250, 1);
              font-size: 0.8vw;
              padding: 0.3vw 0.5vw;
              border-radius: 2vw;
              margin-left: auto;
            "
          >
            <span v-if="Lflag">实时监控</span>
            <span v-else>Real-time Monitoring</span>
          </span>
        </div>

        <div style="display: grid; gap: 3.6vh">
          <!-- 截止阀1 -->
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 1vw;
              border: 0.1vw solid #eee;
              border-radius: 0.5vw;
              background: #f9f9f9;
              transition: background 0.3s;
              width: 30vw;
              height: 6.5vh;
              box-sizing: border-box;
            "
          >
            <div style="display: flex; align-items: center">
              <div
                style="
                  width: 0.8vw;
                  height: 0.8vw;
                  border-radius: 50%;
                  background: #4caf50;
                  margin-right: 1vw;
                  animation: pulse 2s infinite;
                "
                :style="{
                  background: value1 ? '#4CAF50' : '#9E9E9E',
                  animation: value1 ? 'pulse 2s infinite' : 'none',
                }"
              ></div>
              <span style="font-weight: 500; font-size: 1vw"
                ><span v-if="Lflag">进气通道1</span
                ><span v-else>Intake channel 1</span></span
              >
            </div>

            <select
              v-model="value1"
              style="
                width: 8vw;
                border-radius: 0.3vw;
                font-size: 1vw;
                height: 4vh;
                padding: 0.5vw;
                box-sizing: border-box;
                border: 0.1vw solid #ccc;
              "
            >
              <option :value="false">
                <span v-if="Lflag">关</span><span v-else>close</span>
              </option>
              <option :value="true">
                <span v-if="Lflag">开</span><span v-else>open</span>
              </option>
            </select>
          </div>

          <!-- 截止阀2 -->
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 1vw;
              border: 0.1vw solid #eee;
              border-radius: 0.5vw;
              background: #f9f9f9;
              transition: background 0.3s;
              width: 30vw;
              height: 6.5vh;
              box-sizing: border-box;
            "
          >
            <div style="display: flex; align-items: center">
              <div
                style="
                  width: 0.8vw;
                  height: 0.8vw;
                  border-radius: 50%;
                  background: #4caf50;
                  margin-right: 1vw;
                  animation: pulse 2s infinite;
                "
                :style="{
                  background: value2 ? '#4CAF50' : '#9E9E9E',
                  animation: value2 ? 'pulse 2s infinite' : 'none',
                }"
              ></div>
              <span style="font-weight: 500; font-size: 1vw"
                ><span v-if="Lflag">进气通道2</span
                ><span v-else>Intake channel 2</span></span
              >
            </div>

            <select
              v-model="value2"
              style="
                width: 8vw;
                border-radius: 0.3vw;
                font-size: 1vw;
                height: 4vh;
                padding: 0.5vw;
                box-sizing: border-box;
                border: 0.1vw solid #ccc;
              "
            >
              <option :value="false">
                <span v-if="Lflag">关</span><span v-else>close</span>
              </option>
              <option :value="true">
                <span v-if="Lflag">开</span><span v-else>open</span>
              </option>
            </select>
          </div>

          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 1vw;
              border: 0.1vw solid #eee;
              border-radius: 0.5vw;
              background: #f9f9f9;
              transition: background 0.3s;
              width: 30vw;
              height: 6.5vh;
              box-sizing: border-box;
            "
          >
            <div style="display: flex; align-items: center">
              <div
                style="
                  width: 0.8vw;
                  height: 0.8vw;
                  border-radius: 50%;
                  background: #4caf50;
                  margin-right: 1vw;
                  animation: pulse 2s infinite;
                "
                :style="{
                  background: value3 ? '#4CAF50' : '#9E9E9E',
                  animation: value3 ? 'pulse 2s infinite' : 'none',
                }"
              ></div>
              <span style="font-weight: 500; font-size: 1vw"
                ><span v-if="Lflag">进气通道3</span
                ><span v-else>Intake channel 3</span></span
              >
            </div>

            <select
              v-model="value3"
              style="
                width: 8vw;
                border-radius: 0.3vw;
                font-size: 1vw;
                height: 4vh;
                padding: 0.5vw;
                box-sizing: border-box;
                border: 0.1vw solid #ccc;
              "
            >
              <option :value="false">
                <span v-if="Lflag">关</span><span v-else>close</span>
              </option>
              <option :value="true">
                <span v-if="Lflag">开</span><span v-else>open</span>
              </option>
            </select>
          </div>

          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 1vw;
              border: 0.1vw solid #eee;
              border-radius: 0.5vw;
              background: #f9f9f9;
              transition: background 0.3s;
              width: 30vw;
              height: 6.5vh;
              box-sizing: border-box;
            "
          >
            <div style="display: flex; align-items: center">
              <div
                style="
                  width: 0.8vw;
                  height: 0.8vw;
                  border-radius: 50%;
                  background: #4caf50;
                  margin-right: 1vw;
                  animation: pulse 2s infinite;
                "
                :style="{
                  background: value4 ? '#4CAF50' : '#9E9E9E',
                  animation: value4 ? 'pulse 2s infinite' : 'none',
                }"
              ></div>
              <span style="font-weight: 500; font-size: 1vw"
                ><span v-if="Lflag">样气通道</span
                ><span v-else>Sample gas channel</span></span
              >
            </div>

            <select
              v-model="value4"
              style="
                width: 8vw;
                border-radius: 0.3vw;
                font-size: 1vw;
                height: 4vh;
                padding: 0.5vw;
                box-sizing: border-box;
                border: 0.1vw solid #ccc;
              "
            >
              <option :value="false">
                <span v-if="Lflag">关</span><span v-else>close</span>
              </option>
              <option :value="true">
                <span v-if="Lflag">开</span><span v-else>open</span>
              </option>
            </select>
          </div>

          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 1vw;
              border: 0.1vw solid #eee;
              border-radius: 0.5vw;
              background: #f9f9f9;
              transition: background 0.3s;
              width: 30vw;
              height: 6.5vh;
              box-sizing: border-box;
            "
          >
            <div style="display: flex; align-items: center">
              <div
                style="
                  width: 0.8vw;
                  height: 0.8vw;
                  border-radius: 50%;
                  background: #4caf50;
                  margin-right: 1vw;
                  animation: pulse 2s infinite;
                "
                :style="{
                  background: value5 ? '#4CAF50' : '#9E9E9E',
                  animation: value5 ? 'pulse 2s infinite' : 'none',
                }"
              ></div>
              <span style="font-weight: 500; font-size: 1vw"
                ><span v-if="Lflag">零气通道</span
                ><span v-else>Zero gas channel</span></span
              >
            </div>

            <select
              v-model="value5"
              style="
                width: 8vw;
                border-radius: 0.3vw;
                font-size: 1vw;
                height: 4vh;
                padding: 0.5vw;
                box-sizing: border-box;
                border: 0.1vw solid #ccc;
              "
            >
              <option :value="false">
                <span v-if="Lflag">关</span><span v-else>close</span>
              </option>
              <option :value="true">
                <span v-if="Lflag">开</span><span v-else>open</span>
              </option>
            </select>
          </div>

          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 1vw;
              border: 0.1vw solid #eee;
              border-radius: 0.5vw;
              background: #f9f9f9;
              transition: background 0.3s;
              width: 30vw;
              height: 6.5vh;
              box-sizing: border-box;
            "
          >
            <div style="display: flex; align-items: center">
              <div
                style="
                  width: 0.8vw;
                  height: 0.8vw;
                  border-radius: 50%;
                  background: #4caf50;
                  margin-right: 1vw;
                  animation: pulse 2s infinite;
                "
                :style="{
                  background: value6 ? '#4CAF50' : '#9E9E9E',
                  animation: value6 ? 'pulse 2s infinite' : 'none',
                }"
              ></div>
              <span style="font-weight: 500; font-size: 1vw"
                ><span v-if="Lflag">标气通道</span
                ><span v-else>Standard gas channel</span></span
              >
            </div>

            <select
              v-model="value6"
              style="
                width: 8vw;
                border-radius: 0.3vw;
                font-size: 1vw;
                height: 4vh;
                padding: 0.5vw;
                box-sizing: border-box;
                border: 0.1vw solid #ccc;
              "
            >
              <option :value="false">
                <span v-if="Lflag">关</span><span v-else>close</span>
              </option>
              <option :value="true">
                <span v-if="Lflag">开</span><span v-else>open</span>
              </option>
            </select>
          </div>

          <div style="display: flex; justify-content: flex-end; gap: 1vw">
            <button
              style="
                background: rgba(25, 44, 250, 1);
                color: white;
                border: none;
                border-radius: 0.3vw;
                padding: 0.6vw 1.5vw;
                font-size: 0.8vw;
                cursor: pointer;
                transition: background 0.3s;
              "
              @click="setvalue"
            >
              <span v-if="Lflag">设置</span>
              <span v-else>Settings</span>
            </button>
          </div>
        </div>
      </div>

      <div style="width: 5%; height: 90%; float: left"></div>

      <!-- 自动校准参数设置区 -->
      <div style="width: 50%; height: 90%; float: left">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1.5vw;
          "
        >
          <h2
            style="
              font-size: 1.2vw;
              font-weight: bold;
              color: #333;
              display: flex;
              align-items: center;
            "
          >
            <i style="color: rgba(25, 44, 250, 1)"></i>
            <span v-if="Lflag">校准状态</span>
            <span v-else>Calibration status</span>
          </h2>
          <span
            style="
              background: rgba(25, 44, 250, 0.1);
              color: rgba(25, 44, 250, 1);
              font-size: 0.8vw;
              padding: 0.3vw 0.8vw;
              border-radius: 2vw;
            "
          >
            <span v-if="Lflag"
              ><span v-if="progress == 100">校准完成</span
              ><span v-else>校准中···</span></span
            >
            <span v-else
              ><span v-if="progress == 100">Calibration complete</span
              ><span v-else>Calibrating···</span></span
            >
          </span>
        </div>
        <div
          style="
            width: 100%;
            height: 5%;

            justify-content: center;
            align-items: center;
          "
        >
          <el-progress
            :text-inside="true"
            :percentage="progress"
            :stroke-width="20"
            :color="currentColor"
          ></el-progress>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0;
          "
        >
          <h2
            style="
              font-size: 1.2vw;
              font-weight: bold;
              color: #333;
              display: flex;
              align-items: center;
            "
          >
            <span v-if="Lflag">自动校准参数设置区</span>
            <span v-else>Auto Calibration Settings</span>
          </h2>
          <span
            style="
              background: rgba(25, 44, 250, 0.1);
              color: rgba(25, 44, 250, 1);
              font-size: 0.8vw;
              padding: 0.3vw 0.8vw;
              border-radius: 1vw;
              margin: 0;
            "
          >
            <span v-if="Lflag">参数配置</span>
            <span v-else>Parameter Configuration</span>
          </span>
        </div>
        <!-- 气体参数设置 -->
        <div style="margin-bottom: 0.5vh; height: auto">
          <h3
            style="
              font-size: 1em;
              font-weight: 600;
              color: #555;
              margin: 0.3vh;
              display: flex;
              align-items: center;
              padding: 0 0.5vw;
            "
          >
            <i class="fa fa-flask mr-2" style="color: #1e88e5"></i>
            <span v-if="Lflag">气体参数设置</span>
            <span v-else>Gas Parameter Settings</span>
          </h3>

          <div style="display: grid; gap: 0.5vh; padding: 0.5vw">
            <!-- H₂O设置（仅保留名称和浓度） -->
            <div
              style="
                display: grid;
                grid-template-columns: 0.8fr 2fr; /* 移除截止阀列，保留名称和浓度列 */
                gap: 0.5vw;
                align-items: center;
                padding: 0.8vh 0.5vw;
                border: 1px solid #eee;
                border-radius: 0.5vw;
                background: #f9f9f9;
                height: auto;
                min-height: 5vh;
                box-sizing: border-box;
                transition: all 0.3s;
              "
            >
              <div
                style="
                  font-weight: 500;
                  font-size: 0.9em;
                  display: flex;
                  align-items: center;
                  height: 100%;
                "
              >
                H₂O
              </div>
              <div>
                <label
                  style="
                    display: block;
                    font-size: 0.8em;
                    color: #666;
                    margin-bottom: 0.2vh;
                  "
                >
                  <span v-if="Lflag">气体浓度 (ppm)</span>
                  <span v-else>Gas Concentration (ppm)</span>
                </label>
                <div style="display: flex; height: 3vh">
                  <input
                    v-model="H2O_con"
                    type="number"
                    step="any"
                    placeholder="输入浓度值"
                    style="
                      flex: 1;
                      border: 1px solid #ddd;
                      border-right: none;
                      border-radius: 0.3vw 0 0 0.3vw;
                      padding: 0.5vh 0.5vw;
                      font-size: 0.85em;
                      box-sizing: border-box;
                    "
                  />
                  <span
                    style="
                      background: #f1f1f1;
                      border: 1px solid #ddd;
                      border-left: none;
                      border-radius: 0 0.3vw 0.3vw 0;
                      padding: 0.5vh 0.5vw;
                      font-size: 0.85em;
                      display: flex;
                      align-items: center;
                      box-sizing: border-box;
                    "
                    >ppm</span
                  >
                </div>
              </div>
            </div>

            <!-- CO₂设置（仅保留名称和浓度） -->
            <div
              style="
                display: grid;
                grid-template-columns: 0.8fr 2fr;
                gap: 0.5vw;
                align-items: center;
                padding: 0.8vh 0.5vw;
                border: 1px solid #eee;
                border-radius: 0.5vw;
                background: #f9f9f9;
                height: auto;
                min-height: 5vh;
                box-sizing: border-box;
                transition: all 0.3s;
              "
            >
              <div
                style="
                  font-weight: 500;
                  font-size: 0.9em;
                  display: flex;
                  align-items: center;
                  height: 100%;
                "
              >
                CO₂
              </div>
              <div>
                <label
                  style="
                    display: block;
                    font-size: 0.8em;
                    color: #666;
                    margin-bottom: 0.2vh;
                  "
                >
                  <span v-if="Lflag">气体浓度 (ppm)</span>
                  <span v-else>Gas Concentration (ppm)</span>
                </label>
                <div style="display: flex; height: 3vh">
                  <input
                    v-model="CO2_con"
                    type="number"
                    step="any"
                    placeholder="输入浓度值"
                    style="
                      flex: 1;
                      border: 1px solid #ddd;
                      border-right: none;
                      border-radius: 0.3vw 0 0 0.3vw;
                      padding: 0.5vh 0.5vw;
                      font-size: 0.85em;
                      box-sizing: border-box;
                    "
                  />
                  <span
                    style="
                      background: #f1f1f1;
                      border: 1px solid #ddd;
                      border-left: none;
                      border-radius: 0 0.3vw 0.3vw 0;
                      padding: 0.5vh 0.5vw;
                      font-size: 0.85em;
                      display: flex;
                      align-items: center;
                      box-sizing: border-box;
                    "
                    >ppm</span
                  >
                </div>
              </div>
            </div>

            <!-- CH₄设置（仅保留名称和浓度） -->
            <div
              style="
                display: grid;
                grid-template-columns: 0.8fr 2fr;
                gap: 0.5vw;
                align-items: center;
                padding: 0.8vh 0.5vw;
                border: 1px solid #eee;
                border-radius: 0.5vw;
                background: #f9f9f9;
                height: auto;
                min-height: 5vh;
                box-sizing: border-box;
                transition: all 0.3s;
              "
            >
              <div
                style="
                  font-weight: 500;
                  font-size: 0.9em;
                  display: flex;
                  align-items: center;
                  height: 100%;
                "
              >
                CH₄
              </div>
              <div>
                <label
                  style="
                    display: block;
                    font-size: 0.8em;
                    color: #666;
                    margin-bottom: 0.2vh;
                  "
                >
                  <span v-if="Lflag">气体浓度 (ppm)</span>
                  <span v-else>Gas Concentration (ppm)</span>
                </label>
                <div style="display: flex; height: 3vh">
                  <input
                    v-model="CH4_con"
                    type="number"
                    step="any"
                    placeholder="输入浓度值"
                    style="
                      flex: 1;
                      border: 1px solid #ddd;
                      border-right: none;
                      border-radius: 0.3vw 0 0 0.3vw;
                      padding: 0.5vh 0.5vw;
                      font-size: 0.85em;
                      box-sizing: border-box;
                    "
                  />
                  <span
                    style="
                      background: #f1f1f1;
                      border: 1px solid #ddd;
                      border-left: none;
                      border-radius: 0 0.3vw 0.3vw 0;
                      padding: 0.5vh 0.5vw;
                      font-size: 0.85em;
                      display: flex;
                      align-items: center;
                      box-sizing: border-box;
                    "
                    >ppm</span
                  >
                </div>
              </div>
            </div>

            <!-- N₂O设置（仅保留名称和浓度） -->
            <div
              style="
                display: grid;
                grid-template-columns: 0.8fr 2fr;
                gap: 0.5vw;
                align-items: center;
                padding: 0.8vh 0.5vw;
                border: 1px solid #eee;
                border-radius: 0.5vw;
                background: #f9f9f9;
                height: auto;
                min-height: 5vh;
                box-sizing: border-box;
                transition: all 0.3s;
              "
            >
              <div
                style="
                  font-weight: 500;
                  font-size: 0.9em;
                  display: flex;
                  align-items: center;
                  height: 100%;
                "
              >
                N₂O
              </div>
              <div>
                <label
                  style="
                    display: block;
                    font-size: 0.8em;
                    color: #666;
                    margin-bottom: 0.2vh;
                  "
                >
                  <span v-if="Lflag">气体浓度 (ppb)</span>
                  <span v-else>Gas Concentration (ppb)</span>
                </label>
                <div style="display: flex; height: 3vh">
                  <input
                    v-model="N2O_con"
                    type="number"
                    step="any"
                    placeholder="输入浓度值"
                    style="
                      flex: 1;
                      border: 1px solid #ddd;
                      border-right: none;
                      border-radius: 0.3vw 0 0 0.3vw;
                      padding: 0.5vh 0.5vw;
                      font-size: 0.85em;
                      box-sizing: border-box;
                    "
                  />
                  <span
                    style="
                      background: #f1f1f1;
                      border: 1px solid #ddd;
                      border-left: none;
                      border-radius: 0 0.3vw 0.3vw 0;
                      padding: 0.5vh 0.5vw;
                      font-size: 0.85em;
                      display: flex;
                      align-items: center;
                      box-sizing: border-box;
                    "
                    >ppb</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            display: flex;
            align-items: flex-end;
            gap: 1vw;
            padding-bottom: 0.3vw;
          "
        >
          <!-- 校准通气时长部分 -->
          <div style="flex: 1">
            <label
              style="
                display: block;
                font-size: 0.85em; /* 统一字体大小单位 */
                color: #666;
                margin-bottom: 0.2vh; /* 统一标签底部间距 */
              "
            >
              <span v-if="Lflag"> 校准通气时长 (秒)</span>
              <span v-else>Calibration Ventilation Time (sec)</span>
            </label>
            <div style="display: flex; height: 3vh">
              <!-- 统一使用3vh，与气体参数输入框高度一致 -->
              <input
                v-model="CalibrationDuration"
                type="number"
                placeholder="输入秒数"
                style="
                  flex: 1;
                  border: 1px solid #ddd;
                  border-right: none;
                  border-radius: 0.3vw 0 0 0.3vw;
                  padding: 0.5vh 0.5vw; /* 垂直方向用vh，与其他输入框一致 */
                  font-size: 0.85em; /* 统一字体大小单位 */
                  height: 100%;
                  box-sizing: border-box;
                "
              />
              <span
                style="
                  background: #f1f1f1;
                  border: 1px solid #ddd;
                  border-left: none;
                  border-radius: 0 0.3vw 0.3vw 0;
                  padding: 0.5vh 0.5vw;
                  font-size: 0.85em;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  box-sizing: border-box;
                "
              >
                <span v-if="Lflag">秒</span>
                <span v-else>sec</span>
              </span>
            </div>
          </div>

          <!-- 保存按钮部分 -->
          <button
            style="
              background: rgba(25, 44, 250, 1);
              color: white;
              border: none;
              border-radius: 0.3vw;
              padding: 0.5vh 1.5vw; /* 垂直padding用vh，与输入框匹配 */
              font-size: 0.85em; /* 统一字体大小 */
              cursor: pointer;
              transition: background 0.3s;
              height: 3vh; /* 与输入框高度完全一致 */
              box-sizing: border-box;
              display: flex;
              align-items: center;
            "
            @click="setparameter"
          >
            <i class="fa fa-save mr-1"></i>
            <span v-if="Lflag">保存设置</span>
            <span v-else>Save Settings</span>
          </button>
        </div>

        <!-- 校准周期设置 -->
        <div style="margin-bottom: 1vh">
          <!-- 统一使用vh单位 -->
          <h3
            style="
              font-size: 1em;
              font-weight: 600;
              color: #555;
              margin: 0.3vh; /* 缩小底部间距 */
              display: flex;
              align-items: center;
              padding: 0 0.5vw;
            "
          >
            <span v-if="Lflag">校准周期设置</span>
            <span v-else>Calibration Cycle Settings</span>
          </h3>

          <div
            style="
              display: flex;
              align-items: flex-end;
              gap: 1vw;
              padding-bottom: 0.3vw;
            "
          >
            <!-- 自动校准周期输入部分 -->
            <div style="flex: 1">
              <label
                style="
                  display: block;
                  font-size: 0.85em; /* 统一字体大小单位 */
                  color: #666;
                  margin-bottom: 0.2vh; /* 统一标签底部间距 */
                "
              >
                <span v-if="Lflag">自动校准周期 (天)</span>
                <span v-else>Auto Calibration Cycle (days)</span>
              </label>
              <div style="display: flex; height: 3vh">
                <!-- 统一高度为3vh，与其他输入框一致 -->
                <input
                  v-model="CalibratingPeriod"
                  step="1"
                  type="number"
                  :placeholder="Lflag ? '输入天数' : 'Enter days'"
                  style="
                    flex: 1;
                    border: 1px solid #ddd;
                    border-right: none;
                    border-radius: 0.3vw 0 0 0.3vw;
                    padding: 0.5vh 0.5vw; /* 垂直内边距用vh */
                    font-size: 0.85em; /* 统一字体大小 */
                    height: 100%;
                    box-sizing: border-box;
                  "
                />
                <span
                  style="
                    background: #f1f1f1;
                    border: 1px solid #ddd;
                    border-left: none;
                    border-radius: 0 0.3vw 0.3vw 0;
                    padding: 0.5vh 0.5vw;
                    font-size: 0.85em;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    box-sizing: border-box;
                  "
                >
                  <span v-if="Lflag">天</span>
                  <span v-else>days</span>
                </span>
              </div>
            </div>

            <!-- 保存按钮部分 -->
            <button
              style="
                background: rgba(25, 44, 250, 1);
                color: white;
                border: none;
                border-radius: 0.3vw;
                padding: 0.5vh 1.5vw; /* 垂直内边距用vh，与输入框匹配 */
                font-size: 0.85em; /* 统一字体大小 */
                cursor: pointer;
                transition: background 0.3s;
                height: 3vh; /* 与输入框高度完全一致 */
                box-sizing: border-box;
                display: flex;
                align-items: center;
              "
              @click="setcalperiod"
            >
              <i></i>
              <span v-if="Lflag">保存设置</span>
              <span v-else>Save Settings</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import { checkToken } from "@/api/user"; //checkToken从/api/user导入，作用是发送网络请求让后端检查token
import { sendcommand } from "@/api/data";
import { ask_real_time_data } from "@/api/data";
import { getSelectInfo } from "@/api/data";
import { mapGetters } from "vuex";
export default {
  data() {
    // 是否包含一位数字
    return {
      project: [], //用于接收项目列表
      username: "", //用于接收用户名
      token: "", //用于接收token
      Lflag: true,
      table: "",
      database: "",
      command: "",
      password: "",
      value1: 0,
      value2: 0,
      value3: 0,
      value4: 0,
      value5: 0,
      value6: 0,
      CalibratingPeriod: 0,
      CalibrationDuration: 0,
      H2O_SET: 0,
      H2O_con: 0,
      CO2_SET: 0,
      CO2_con: 0,
      CH4_SET: 0,
      CH4_con: 0,
      N2O_SET: 0,
      N2O_con: 0,
      optionalColumnList: [],
      dataList: [],
      isRefreshing: false, // 加载状态标志位
      drawer: false,
      windowWidth: window.innerWidth, // 保存当前视口宽度
      baseVw: 18, // 基准vw值，相当于 25vw
      progress: 100,
      time_count: 0,
      base_time_s: 0,
      calib_index: 0,
      reset_flag: false,
    };
  },
  created: async function () {
    this.$store.commit("restoretoken"); //将roken从本地传到store
    checkToken(this.$qs.stringify({ token: this.$store.state.token })).then(
      (res) => {
        //让后端检查token
        if (res != null) {
          //如果后端返回不为空则为登陆成功
          this.loginCheck = true;
        }
        console.log(res);
        console.log(this.$store.state.token);
        console.log("state====", this.$store.state);
        console.log("email====", this.$store.state.email);
      }
    );
    this.$store.commit("restorename"); //将保存在本地的用户名传到store
    this.$store.commit("restoLanguage"); //将保存在本地的项目名传给state
    this.username = this.$store.state.username; //将store里的用户名传到该组件

    this.Lflag = this.$store.state.Language; //store里的传到该组件
    console.log(this.Lflag);
    this.$store.commit("restoreproject"); //将保存在本地的项目名传给state
    this.project = this.$store.state.project; //将state里的project赋值给组件里的project
    this.database = this.project[0];
    console.log(this.database, this.table);
    this.table = this.$store.state.site + "_map"; //将分割出的第二部分赋值给table并且加上后缀
    getSelectInfo(
      this.$qs.stringify({
        database: this.database,
        table: this.table,
      })
    ).then((res) => {
      console.log(this.database, res.data);
      this.optionalColumnList = res.data;
      this.refresh(0);
    });
  },
  computed: {
    // 根据进度计算颜色
    currentColor() {
      // 进度0-100%对应的颜色从蓝色(#1890FF)过渡到绿色(#52C41A)
      const blue = { r: 24, g: 144, b: 255 }; // 蓝色RGB值
      const green = { r: 82, g: 196, b: 26 }; // 绿色RGB值

      // 计算当前进度对应的颜色比例
      const ratio = this.progress / 100;

      // 计算过渡色的RGB值
      const r = Math.round(blue.r + (green.r - blue.r) * ratio);
      const g = Math.round(blue.g + (green.g - blue.g) * ratio);
      const b = Math.round(blue.b + (green.b - blue.b) * ratio);

      // 转换为十六进制颜色
      return `rgb(${r}, ${g}, ${b})`;
    },
    // 计算vw对应的像素值
    prog_with() {
      // vw转换公式：1vw = 视口宽度的1%
      // 所以 Nvw = windowWidth * (N / 100)
      return this.windowWidth * (this.baseVw / 100);
    },
  },
  mounted() {
    // 监听主界面的语言切换事件
    this.$bus.$on("language-changed", (flag) => {
      this.Lflag = flag;
    });
    // 监听窗口大小变化
    window.addEventListener("resize", this.handleResize);
    this.refreshData = setInterval(() => {
      this.refresh(2);
    }, 5000);
  },
  beforeDestroy() {
    // 销毁时移除事件监听，避免内存泄漏
    this.$bus.$off("language-changed");
    // 移除监听
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.refreshData);
    this.refreshData = null;
  },
  methods: {
    handleResize() {
      // 防抖处理
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.windowWidth = window.innerWidth;
      }, 100);
    },
    setcommand() {
      this.isRefreshing = true;
      this.table = this.$store.state.site;
      this.password = "66668888";
      console.log(this.database, this.table, this.command, this.password);
      sendcommand(
        this.$qs.stringify({
          database: this.database,
          table: this.table,
          command: this.command,
          password: this.password,
        })
      ).then((res) => {
        console.log(res.data);
        var text = "设置失败";
        if (res.data.status == "success") {
          setTimeout(() => {
            this.refresh(1);
          }, 2500); // 2.5秒延迟
        } else {
          if (this.Lflag == false) {
            text = "Failed to save settings";
          }
          this.optionMin = this.$message({
            showClose: true,
            message: text,
            center: true,
            type: "error",
            customClass: "customclass",
          });
        }
      });
    },
    refresh(flag) {
      this.table = this.$store.state.site + "_dat";
      ask_real_time_data(
        this.$qs.stringify({
          database: this.database,
          table: this.table,
        })
      ).then((res) => {
        // 1. 缓存更新前的所有需要对比的变量（完整收集）
        const prevData = {
          value1: this.value1,
          value2: this.value2,
          value3: this.value3,
          value4: this.value4,
          value5: this.value5,
          value6: this.value6,
          H2O_SET: this.H2O_SET,
          CO2_SET: this.CO2_SET,
          CH4_SET: this.CH4_SET,
          N2O_SET: this.N2O_SET,
          H2O_con: this.H2O_con,
          CO2_con: this.CO2_con,
          CH4_con: this.CH4_con,
          N2O_con: this.N2O_con,
          CalibratingPeriod: this.CalibratingPeriod,
          CalibrationDuration: this.CalibrationDuration,
        };

        // 2. 初始化成功标记（局部变量，避免全局污染）
        let success_flag = 1;

        // 3. 更新数据列表
        this.dataList = res.data;
        //console.log(res.data);

        // 4. 处理参数映射（复用映射表优化逻辑）
        const paramMap = {
          Static_Air_Valve_1: (v) => {
            this.value1 = Boolean(v);
          },
          Static_Air_Valve_2: (v) => {
            this.value2 = Boolean(v);
          },
          Static_Air_Valve_3: (v) => {
            this.value3 = Boolean(v);
          },
          Static_Air_Valve_4: (v) => {
            this.value4 = Boolean(v);
          },
          Static_Air_Valve_5: (v) => {
            this.value5 = Boolean(v);
          },
          Static_Air_Valve_6: (v) => {
            this.value6 = Boolean(v);
          },
          Static_H2o_Airvalve: (v) => {
            this.H2O_SET = v;
          },
          Static_H2o_Gascon: (v) => {
            this.H2O_con = v;
          },
          Static_Co2_Airvalve: (v) => {
            this.CO2_SET = v;
          },
          Static_Co2_Gascon: (v) => {
            this.CO2_con = v;
          },
          Static_Ch4_Airvalve: (v) => {
            this.CH4_SET = v;
          },
          Static_Ch4_Gascon: (v) => {
            this.CH4_con = v;
          },
          Static_N2o_Airvalve: (v) => {
            this.N2O_SET = v;
          },
          Static_N2o_Gascon: (v) => {
            this.N2O_con = v * 1000;
          },
          Static_set_circount_h: (v) => {
            this.CalibratingPeriod = Number(v);
          },
          Static_set_calcount_s: (v) => {
            this.CalibrationDuration = Number(v);
          },
          Static_time_count: (v) => {
            this.time_count = Number(v);
          },
        };

        // 遍历更新数据
        this.optionalColumnList.forEach((item) => {
          const handler = paramMap[item.paramName];
          if (handler && this.dataList.hasOwnProperty(item.paramIndex)) {
            if (flag == 2) {
              if (item.paramName == "Static_time_count") {
                handler(this.dataList[item.paramIndex]);
              }
            } else {
              handler(this.dataList[item.paramIndex]);
            }
          }
        });

        this.calib_index =
          Number(Boolean(this.H2O_SET)) +
          Number(Boolean(this.CO2_SET)) +
          Number(Boolean(this.CH4_SET)) +
          Number(Boolean(this.N2O_SET));

        this.base_time_s = (this.CalibrationDuration + 120) * this.calib_index;
        if (this.time_count == 0) {
          this.progress = 100;
        } else if (this.time_count >= this.base_time_s) {
          this.progress = 99.9;
        } else {
          this.progress = Number(
            parseFloat((this.time_count / this.base_time_s) * 100).toFixed(1)
          );
        }
        //console.log(this.time_count, this.base_time_s, this.progress);

        // 5. 统一格式化（移到循环外，只执行一次）
        this.H2O_con = parseFloat(this.H2O_con).toFixed(0);
        this.CO2_con = parseFloat(this.CO2_con).toFixed(0);
        this.CH4_con = parseFloat(this.CH4_con).toFixed(0);
        this.N2O_con = parseFloat(this.N2O_con).toFixed(0);

        // 6. 当flag=1时，对比更新前后的数据
        if (flag == 1) {
          // 定义需要对比的字段（与prevData对应）
          const compareFields = [
            "value1",
            "value2",
            "value3",
            "value4",
            "value5",
            "value6",
            "H2O_SET",
            "CO2_SET",
            "CH4_SET",
            "N2O_SET",
            "H2O_con",
            "CO2_con",
            "CH4_con",
            "N2O_con",
            "CalibratingPeriod",
            "CalibrationDuration",
          ];

          // 遍历对比所有字段
          for (const field of compareFields) {
            if (prevData[field] != this[field]) {
              //console.log(field, prevData[field], this[field]);
              success_flag = 0; // 发现不一致，标记失败
              break; // 无需继续对比
            }
          }
          var text = "设置成功";
          if (this.Lflag == false) {
            text = "Settings saved successfully";
          }
          if (success_flag) {
            this.optionMin = this.$message({
              showClose: true,
              message: text,
              center: true,
              type: "success",
              customClass: "customclass",
            });
          } else {
            text = "设置失败";
            if (this.Lflag == false) {
              text = "Failed to save settings";
            }
            this.optionMin = this.$message({
              showClose: true,
              message: text,
              center: true,
              type: "error",
              customClass: "customclass",
            });
          }
        }
        this.isRefreshing = false;
      });
    },
    restart() {
      this.command = "hexvalve_" + this.binaryToHex("01000000");
      this.setcommand();
      this.reset_flag = false;
    },
    setvalue() {
      // 定义一个工具函数，将布尔值转换为 1/0
      const boolToNum = (bool) => (bool ? 1 : 0);
      this.command =
        "hexvalve_" +
        this.binaryToHex(
          "00" +
            boolToNum(this.value6) +
            boolToNum(this.value5) +
            boolToNum(this.value4) +
            boolToNum(this.value3) +
            boolToNum(this.value2) +
            boolToNum(this.value1)
        );
      this.setcommand();
    },
    binaryToHex(binaryStr) {
      // 校验输入是否为有效的二进制字符串
      if (!/^[01]+$/.test(binaryStr)) {
        throw new Error("请输入有效的二进制字符串（仅包含0和1）");
      }

      // 补零使长度为4的倍数（从左侧补零）
      const paddingLength = (4 - (binaryStr.length % 4)) % 4;
      const paddedBinary = "0".repeat(paddingLength) + binaryStr;

      // 二进制到十六进制的映射表
      const hexMap = {
        "0000": "0",
        "0001": "1",
        "0010": "2",
        "0011": "3",
        "0100": "4",
        "0101": "5",
        "0110": "6",
        "0111": "7",
        1000: "8",
        1001: "9",
        1010: "A",
        1011: "B",
        1100: "C",
        1101: "D",
        1110: "E",
        1111: "F",
      };

      let hexStr = "";
      // 每4位二进制转换为1位十六进制
      for (let i = 0; i < paddedBinary.length; i += 4) {
        const chunk = paddedBinary.slice(i, i + 4);
        hexStr += hexMap[chunk];
      }

      return hexStr;
    },
    toHexLittleEndian(num, len) {
      // 1. 校验输入
      const numVal = Number(num);
      if (isNaN(numVal)) {
        console.error("输入不是有效的数字");
        return "";
      }
      if (len <= 0) {
        console.error("字节长度必须为正数");
        return "";
      }

      // 2. 转换为指定字节长度的十六进制（大端序），并补零
      const totalChars = len * 2; // 每个字节对应2位十六进制
      let hexBigEndian = numVal
        .toString(16)
        .padStart(totalChars, "0")
        .toUpperCase();
      // 确保长度为偶数（避免补零后长度异常）
      if (hexBigEndian.length > totalChars) {
        hexBigEndian = hexBigEndian.slice(-totalChars); // 超出长度时取低位
      }

      // 3. 转换为小端序（按字节反转）
      const bytes = [];
      for (let i = 0; i < totalChars; i += 2) {
        // 截取大端序中的每个字节（2位十六进制）
        const byte = hexBigEndian.slice(i, i + 2);
        bytes.push(byte);
      }
      // 反转字节数组（小端序：低位字节在前）
      const bytesLittleEndian = bytes.reverse();
      // 拼接为小端序十六进制字符串
      return bytesLittleEndian.join("");
    },
    float32ToHex(floatNum) {
      // 创建4字节缓冲区（32位）
      const buffer = new ArrayBuffer(4);
      const dataView = new DataView(buffer);

      // 写入32位浮点数（大端序，符合IEEE 754标准）
      // 第三个参数false表示大端序（高位字节在前）
      dataView.setFloat32(0, floatNum, true);

      let hexStr = "";
      // 读取4个字节，每个字节转换为2位十六进制
      for (let i = 0; i < 4; i++) {
        const byte = dataView.getUint8(i);
        hexStr += byte.toString(16).padStart(2, "0").toUpperCase();
      }

      return hexStr;
    },
    setcalperiod() {
      this.command =
        "hexcalperiod_" + this.toHexLittleEndian(this.CalibratingPeriod, 2);
      this.setcommand();
    },
    setparameter() {
      this.H2O_SET = this.CO2_SET = this.CH4_SET = this.N2O_SET = 6;
      if (this.H2O_con == 0) {
        this.H2O_SET = 0;
      }
      if (this.CO2_con == 0) {
        this.CO2_SET = 0;
      }
      if (this.CH4_con == 0) {
        this.CH4_SET = 0;
      }
      if (this.N2O_con == 0) {
        this.N2O_SET = 0;
      }

      this.command =
        "hexcalibration_" +
        this.toHexLittleEndian(this.H2O_SET, 1) +
        this.float32ToHex(this.H2O_con) +
        this.toHexLittleEndian(this.CO2_SET, 1) +
        this.float32ToHex(this.CO2_con) +
        this.toHexLittleEndian(this.CH4_SET, 1) +
        this.float32ToHex(this.CH4_con) +
        this.toHexLittleEndian(this.N2O_SET, 1) +
        this.float32ToHex(this.N2O_con / 1000) +
        this.toHexLittleEndian(this.CalibrationDuration, 2);
      this.setcommand();
    },
  },
};
</script>

<style>
/* 添加颜色过渡动画 */
.progress-transition /deep/ .el-progress-circle__path {
  transition: stroke 0.5s ease-in-out;
}
.el-button--button {
  width: 6.0215vw;
  height: 2.3656vw;
  color: #fff;
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  opacity: 1;
  text-align: left;
}
.img {
  display: flex;
  justify-content: right;
  align-items: center;
}

.left1 {
  width: 16%;
  height: 99%;
  float: left;
}

.right1 {
  width: 84%;
  height: 99%;
  float: left;
  display: flex;
}

.down1::after {
  /*清除浮动*/
  content: "";
  display: block;
  clear: both;
}

.v35_1032 {
  width: 0.8065vw;
  height: 0.8065vw;
  background: rgba(25, 44, 250, 1);
  opacity: 1;
  position: absolute;
  border-radius: 50%;
}

.v35_1047 {
  width: 6.8817vw;
  color: rgba(25, 44, 250, 1);
  position: absolute;
  font-family: Microsoft YaHei UI;
  font-weight: Bold;
  font-size: 1.6129vw;
  opacity: 1;
  text-align: left;
}

.v35_1026 {
  width: 1.7204vw;
  color: rgba(0, 0, 0, 1);
  position: absolute;
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  opacity: 1;
  text-align: left;
}

.v35_1037 {
  background: rgba(244, 249, 255, 1);
  opacity: 1;
  position: absolute;
  overflow: hidden;
}

.v35_1044 {
  color: rgba(255, 255, 255, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  opacity: 1;
  text-align: left;
}

.v35_1039 {
  color: rgba(0, 0, 0, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Bold;
  font-size: 1.0753vw;
  opacity: 1;
  text-align: left;
  display: flex;
  justify-content: left;
}

.v35_1040 {
  color: rgba(0, 0, 0, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  opacity: 1;
  text-align: left;
}

.v35_1033 {
  width: 5.1613vw;
  color: rgba(0, 0, 0, 1);
  position: absolute;
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 1.0753vw;
  opacity: 1;
  text-align: left;
}

.v35_316 {
  width: 100%;
  height: 100vh;
  background: rgba(240, 240, 240, 1);
  opacity: 1;
  position: relative;
  top: 0vw;
  left: 0vw;
  overflow: hidden;
}

.v14_4873::after {
  /*清除浮动*/
  content: "";
  display: block;
  clear: both;
}

.v14_4877 {
  width: 2.4%;
  color: rgba(0, 0, 0, 1);
  position: absolute;
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  opacity: 1;
  text-align: right;
}

.v14_4873 {
  width: 100%;
  height: 10%;
  background: rgba(255, 255, 255, 1);
  opacity: 1;
  position: relative;
  overflow: hidden;
}

.v14_4874 {
  width: 5.1613vw;
  color: rgba(25, 44, 250, 1);
  position: absolute;
  font-family: Microsoft YaHei UI;
  font-weight: Bold;
  font-size: 1.7204vw;
  opacity: 1;
  text-align: left;
}

.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 3.2258vw;
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 10.7527vw;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  line-height: 8.6022vw;
}

body > .el-container {
  margin-bottom: 2.1505vw;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 13.9785vw;
}

.el-container:nth-child(7) .el-aside {
  line-height: 17.2043vw;
}

.right-align {
  float: right;
  height: 2.1505vw;
  margin-top: 0.5376vw;
}

.logout {
  height: 1.6129vw;
}

.classRow {
  width: 25%;
  display: flex;
}

.classCenter {
  width: 50%;
  box-flex: 5;
  -webkit-box-flex: 5;
  -moz-box-flex: 5;
  -webkit-flex: 5;
  -ms-flex: 5;
  flex: 5;

  display: flex;
  justify-content: center;
}

.classRight {
  width: 25%;
  box-flex: 1;
  /*灵活度*/
  -webkit-box-flex: 1;
  /* Safari and Chrome */
  -moz-box-flex: 1;
  /* Firefox */
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;

  display: flex;
  justify-content: flex-end;
}
.status-success {
  height: 0.9375rem;
  width: 0.9375rem;
  margin-right: 0.5rem;
  background-color: lime;
  border-radius: 100%;
}
.status-warning {
  height: 0.9375rem;
  width: 0.9375rem;
  margin-right: 0.5rem;
  background-color: yellow;
  border-radius: 100%;
}
.status-serious {
  height: 0.9375rem;
  width: 0.9375rem;
  margin-right: 0.5rem;
  background-color: red;
  border-radius: 100%;
}
.status-cutContact {
  height: 0.9375rem;
  width: 0.9375rem;
  margin-right: 0.5rem;
  background-color: darkgrey;
  border-radius: 100%;
}
.status-connectErr {
  height: 0.9375rem;
  width: 0.9375rem;
  margin-right: 0.5rem;
  background-color: wheat;
  border-radius: 100%;
}
.tips {
  margin-right: 1.25rem;
  display: flex;
  align-items: center;
}

.syMain {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.topTip {
  text-align: center;
  line-height: 30px;
  color: red;
  font-weight: 700;
  margin: 10px 0;
}

.tip {
  color: red;
  margin-top: 20px;
}

.tip p {
  margin: 5px;
}

.ImgTip {
  text-align: center;
  margin: 0 auto;
}

.ImgTip p {
  margin: 20px 0;
}
</style>
